import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import UserAddedCIP from "../components/AddCIPAndShutdown";
import TrainSelector from "../components/TrainSelector";
import CostInformation from "../pages/costInformation";
import DefaultCIPInformation from "../pages/defaultCIPInformation";
import FoulingIdentification from "../pages/foulingIdentification";
import HistoricalCIPEffectivness from "../pages/historialCIPsEffectivness";
import IdentifyCIP from "../pages/home/identifyCIP";
import Settings from "../pages/home/Settings";
import PlantInformation from "../pages/plantsPage/plantInformation";
import PredictCIP from "../pages/predict";

import { getDuplicateItems } from "../utils/Utils";

import { getfoulingType } from "../network/cipAPI";

import { storeFoulingType } from "../Store/TemplateStore/template.action";

import "./index.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

const XLSFileUpload = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    activeStep,
    setActiveStep,
    isFirstTimeLoad,
    isBackClicked,
    setDisableNextButton,
    setSettingsButton,
  } = props;
  const { file_id, cips } = useSelector((state) => ({
    file_id: state.file_id,
    cips: state.cips,
  }));
  const [duplicateCip, setDuplicateCip] = useState(false);

  const fileRef = useRef(null);
  const plantRef = useRef(null);
  const defaultInfo = useRef(null);
  const settingsRef = useRef(null);

  const onNextClicked = async () => {
    if (activeStep === 1) {
      const response = await getfoulingType();
      if (response && response.data) dispatch(storeFoulingType(response.data));
      const cipCopy = { ...cips };
      const cipsStartDate = Object.values(cipCopy).map(
        (item) => item.start_date,
      );
      const duplicateCips = getDuplicateItems(cipsStartDate);
      setDuplicateCip(duplicateCips);
      if (duplicateCips.length <= 0) {
        setActiveStep(activeStep + 1);
      }
    } else {
      if (settingsRef && settingsRef.current) {
        settingsRef.current.settingsInformation();
      }
      if (fileRef && fileRef.current) {
        fileRef.current.performanceData();
      }
      if (plantRef && plantRef.current) {
        plantRef.current.plantInformation();
      }
    }
  };

  React.useImperativeHandle(ref, () => ({ onNextClicked }));

  return (
    <div>
      <div className="flex-jc-center">
        <TrainSelector disabled={activeStep !== 0} />
      </div>
      {activeStep === 0 && (
        <div className="uploadContainer">
          <div className="descriptionText">
            {t("plantInformationStrings.description")}
          </div>
          <PlantInformation
            ref={plantRef}
            setActiveStep={setActiveStep}
            mandatoryThresholdFilled={true}
          />
          <Settings
            ref={settingsRef}
            fileId={file_id}
            isBackClicked={isBackClicked}
            disabled={true}
          />
          <CostInformation disabled />
          <DefaultCIPInformation
            disabled
            ref={defaultInfo}
            setActiveStep={setActiveStep}
          />
          <UserAddedCIP isFirstTimeLoad={isFirstTimeLoad} />
        </div>
      )}
      {activeStep === 1 && (
        <IdentifyCIP
          duplicateCip={duplicateCip}
          setDuplicateCip={setDuplicateCip}
          activeStep={activeStep}
          setSettingsButton={setSettingsButton}
        />
      )}
      {activeStep === 2 && (
        <HistoricalCIPEffectivness
          activeStep={activeStep}
          setSettingsButton={setSettingsButton}
          setDisableNextButton={setDisableNextButton}
        />
      )}
      {activeStep === 3 && <FoulingIdentification activeStep={activeStep} />}
      {activeStep === 4 && (
        <PredictCIP
          setDisableNextButton={setDisableNextButton}
          setSettingsButton={setSettingsButton}
        />
      )}
    </div>
  );
});

export default XLSFileUpload;
